import { render, staticRenderFns } from "./CategorySearchInput.vue?vue&type=template&id=36e80742&scoped=true"
import script from "./CategorySearchInput.vue?vue&type=script&lang=js"
export * from "./CategorySearchInput.vue?vue&type=script&lang=js"
import style0 from "./CategorySearchInput.vue?vue&type=style&index=0&id=36e80742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e80742",
  null
  
)

export default component.exports